export default "__VITE_ASSET__50d0c808__"